import React, { useState } from 'react'
import { Form, Input, Modal,  App, Button } from 'antd';
import { useKehuyhzhAddMutation } from '../../store/DianShangYeWuApi';
import Icon from '../../cpn/Icon';

function ClientBankAdd(props) {
    const [open, setOpen] = useState(false);
    const { message } = App.useApp();   
    const [info, setInfo] = useState({
        khyhzh_kh_id: props.kh_id,
        khyhzh_bank: '',
        khyhzh_code: '',
        khyhzh_name: '',
        khyhzh_cid: props.yh_id,
        khyhzh_cname: props.yh_name,
        khyhzh_content: '',
    });
    const [form] = Form.useForm();
    const [submit] = useKehuyhzhAddMutation();
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} title='新增银行账户'/>
            <Modal
                open={open}
                title='新增银行账户'
                width={800}
                onCancel={() => {setOpen(false)}} 
                footer={[
                    <Button key='submit' type='primary' onClick={() => {                        
                        submit(info).then(res => {
                            if(res.data.Status === 'success'){
                                message.success('新增成功');
                                setOpen(false);
                                form.resetFields();
                                setInfo(prevState=>({...prevState,khyhzh_name:'',khyhzh_bank:'',khyhzh_code:'',khyhzh_content:''}))
                            }else{
                                message.error('新增失败'+res.data.Message);
                            }
                        });
                    }}>保存</Button>,
                    <Button key='reset' onClick={() => {
                        form.resetFields();
                        setInfo(prevState=>({...prevState,khyhzh_name:'',khyhzh_bank:'',khyhzh_code:'',khyhzh_content:''}))
                    }}>重置</Button>,
                ]}
            >
                <Form form={form} name='form_client_bank_add' labelCol={{span: 4}} wrapperCol={{span: 20}}>
                    <Form.Item name='khyhzh_name' label='账户名称' rules={[{ required: true, message: '请输入账户名称' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khyhzh_name: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khyhzh_bank' label='开户银行' rules={[{ required: true, message: '请输入开户银行' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khyhzh_bank: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khyhzh_code' label='银行账号' rules={[{ required: true, message: '请输入银行账号' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khyhzh_code: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khyhzh_content' label='备注'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khyhzh_content: e.target.value}))}} />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientBankAdd